// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Fdmc","selected":"styles_selected__10vN6"};